var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSection2Option1 = function SvgSection2Option1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 18,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m17.5 0-.16.03L12 2.1 6 0 .36 1.9c-.21.07-.36.25-.36.48V17.5c0 .28.22.5.5.5l.16-.03L6 15.9l6 2.1 5.64-1.9c.21-.07.36-.25.36-.48V.5c0-.28-.22-.5-.5-.5ZM7 2.47l4 1.4v11.66l-4-1.4V2.47Zm-5 .99 3-1.01v11.7l-3 1.16V3.46Zm14 11.08-3 1.01V3.86l3-1.16v11.84Z",
    fill: "#535659"
  })));
};
export default SvgSection2Option1;